<template>
  <div>
    <CModal
        :centered="true"
        :show.sync="addGradeModal"
        :title="`${this.student.name} ${this.student.lastname}`"
        class="text-right"
        size="md"
    >
      <CInput
          v-model="form.mark"
          :label="student.klass.grade.id < 7 ? 'درصد عملکرد' : 'نمره'"
          class="text-sm"
          type="number"
      />
      <CTextarea
          v-model="form.text"
          :label="student.klass.grade.id < 7 ? 'گزارش عملکرد': 'نمره به حروف'"
          class="text-sm mt-2"
      />
      <template #footer>
        <CButton v-if="!student.examMark" :loading="loading" color="primary" @click="onAddMark">
          ثبت
        </CButton>
        <CButton v-else :loading="loading" color="primary" @click="onPutMark">
          ویرایش
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: {
    value: {
      type: Boolean,
    },
    student: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      form: {},
    };
  },
  computed: {
    addGradeModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    // modalTitle() {
    //   return this.student.examMark ? `ویرایش نمره - ${this.student.name} ${this.student.lastname}` : `ثبت نمره - ${this.student.name} ${this.student.lastname}`
    // }
  },
  watch: {
    addGradeModal(newValue) {
      if (newValue)
        this.form = {
          mark: this.student.examMark,
          text: this.student.markText
        };
    },
  },
  methods: {
    async onAddMark() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const payload = {
          examId: examId,
          studentId: this.student.id,
          mark: this.form.mark,
          text: this.form.text
        };
        await axios.post("/mark", payload);
        this.addGradeModal = false;
        this.$emit("get-mark");
        this.$emit('get-exam')
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    async onPutMark() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const payload = {
          examId: examId,
          studentId: this.student.id,
          mark: this.form.mark,
          text: this.form.text
        };
        await axios.put(`/mark/${this.student.examMarkId}`, payload);
        this.addGradeModal = false;
        this.$emit("get-mark");
        this.$emit('get-exam')
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>